import React from "react";
import { HorizontalTicker } from "react-infinite-ticker";
import Box from "./box";

interface TickerProps {
  image?: string; // Type for the image prop
  children: React.ReactNode; // Type for the children prop
  duration: number;
}

const Ticker: React.FC<TickerProps> = ({ image, children, duration }) => (
  <Box
    localStyles={{
      "> div": {
        position: "fixed",
        top: 0,
        left: 0,
        background: "color-mix(in srgb, var(--background) 100%, black 100%)",
        borderBottom: "1px solid rgba(0,0,0,.6)",
        color: "#fff",
        zIndex: 1000,
        // backgroundImage: `linear-gradient(
        //   to bottom,
        //   rgb(0 0 0 / 70%),
        //   rgb(0 0 0 / 70%)
        // ),
        // url("${image}")`,
        // backgroundPosition: "center center, center center",
        // backgroundRepeat: "no-repeat, no-repeat",
        // backgroundSize: "cover, cover",
        // backgroundAttachment: "fixed",
        padding: "10px 20px 10px",
      },
      "> div > div": {
        flex: "0 0 auto",
        textAlign: "center",
        alignItems: "center",
      },
    }}
  >
    <HorizontalTicker duration={duration}>{children}</HorizontalTicker>
  </Box>
);

// Export the Ticker component
export default Ticker;
